<template>
  <article class="maintenace" :class="{'maintenace__popup-default': !plateNumberList.length > 0}">
    <section v-if="!showRelatedPlateNumberPopup">
      <group>
        <cell class="maintenace__plate">
          <span slot="icon">
            <x-input
              placeholder="未关联车辆"
              :readonly="true"
              v-model="plate_number">
              <span slot="right" v-if="plate_number" class="weui_icon_clear" @click="handleClearRelatedPlateNumber"></span>
            </x-input>
          </span>
          <div slot="child">
            <x-button class="btn-radius" @click.native="showRelatedPlateNumberPopup = true">关联车辆</x-button>
          </div>
        </cell>
      </group>

      <group>
        <cell primary="content">
          <div slot="icon" class="weui_label">保有类型</div>
          <radio class="ins-radio" :options="insOptions" v-if="!is_disabled" v-model="maintenace.ins_type" @on-change="insTypeChange"></radio>
          <span slot="value" v-else>{{maintenace.ins_type === 1 ? '保内' : '保外'}}</span>
        </cell>
        <datetime
          v-model="maintenace.last_maintain_date"
          title="保养日期"
          class="time-picker"
          confirm-text="完成"
          cancel-text="取消"
          format="YYYY-MM-DD"
          :start-date="startDate"
          :end-date="endDate"
          placeholder="请选择最后保养日期">
        </datetime>
        <x-input
          title="免保剩余"
          :readonly="is_disabled"
          v-if="maintenace.ins_type === 1"
          placeholder="请输入剩余保养次数"
          v-model="maintenace.free_ins_left_count"
        >
        </x-input>
        <x-input
          title='保养里程'
          placeholder="请输入最后保养里程"
          v-model="maintenace.last_maintain_mileage">
        </x-input>
        <datetime
          v-if="!is_disabled"
          v-model="maintenace.purchase_date"
          title="购车日期"
          class="time-picker"
          confirm-text="完成"
          cancel-text="取消"
          format="YYYY-MM-DD"
          :start-date="startDate"
          :end-date="endDate"
          placeholder="请选择购车日期">
        </datetime>
        <cell v-else primary="content">
          <div slot="icon" class="weui_label">购车日期</div>
          <span slot="value">{{maintenace.purchase_date || '--'}}</span>
        </cell>
        <selector
          v-if="maintenace.ins_type === 1"
          v-model="maintenace.repair_category_id"
          placeholder="请选择"
          title="保修分类"
          :class="{'type-disabled': is_disabled}"
          :readonly="is_disabled"
          :options="powerTypeList">
        </selector>
      </group>
      <section class="btn-bottom">
        <div class="btn-fix">
          <a class="btn" @click.stop="handleSubmit">试算</a>
        </div>
      </section>
    </section>
    <!-- 关联车牌号弹层 -->
    <section v-else class="maintenace__popup-plate">
      <div class="search-header">
        <input class="search-header__input" @input="handlePlateNumberInput" v-model="plate_number" placeholder="请输入车牌号码" type="text">
      </div>
      <div v-if="plateNumberList.length > 0">
        <div v-for="(item, index) in plateNumberList" class="search-popupp" :key="index" @click="handleSelectRelatedPlateNumber(item)">
          <p class="search-popupp__items-number">{{ item.plate_number || '--' }}</p>
          <p class="search-popupp__items-name">{{ item.car_model_name || '--' }}</p>
        </div>
      </div>
      <section class="data-messages-null" v-else>
        <img src="../../stylesheets/images/icon/no-vehicwle-icon.jpg" class="no-vehicle" width="88" height="88"/>
        <br><br>
        请查询需要关联的车辆
      </section>
    </section>
    <popup v-model="maintenanceTrialConfirm">
      <!-- 根据保养到期天数 处理不同弹窗逻辑 -->
      <div class="maintenace-trial__result" v-if="maxperiodDays">
        <cell class="maintenace-trial__result-title">
          <p class="vux-close" @click="maintenanceTrialConfirm = false"></p>
        </cell>
        <div class="maintenace-trial__result-date">
          已超过设置保养周期最大值{{maxperiodDays}}天，
          <br><br>
          请输入“保养里程”再进行试算！
        </div>
        <x-button class="maintenace-trial__result-btn" type="primary" @click="maintenanceTrialConfirm = false">确认</x-button>
      </div>
      <div class="maintenace-trial__result" v-else>
        <cell class="maintenace-trial__result-title"  title="试算结果" >
          <p class="vux-close" @click="maintenanceTrialConfirm = false"></p>
        </cell>
        <div class="maintenace-trial__result-date">
          预计下次保养日期
          <p>{{fixed_maintain_date}}</p>
        </div>
        <p v-if="!plate_number" class="maintenace-trial__result-txt">若需同步更新到系统，请先关联车辆</p>
        <x-button v-else class="maintenace-trial__result-btn" type="primary" @click.native="handleFixedMaintainDateSync">同步更新到系统</x-button>
      </div>
    </popup>
    <confirm
      title="是否把试算结果更新到系统？"
      cancelText="取消"
      confirmText="保存"
      v-model="show"
      @on-cancel="handleOnCancel"
      @on-confirm="handleOnConfirm">
    </confirm>
  </article>
</template>

<script>
import {
  Group,
  Radio,
  Cell,
  XInput,
  Datetime,
  Selector,
  XButton,
  Popup,
  Icon,
  Confirm
} from '@lx-frontend/cvux'
import util from '../../common/util'

export default {
  components: {
    Group,
    Cell,
    Radio,
    XInput,
    Datetime,
    Selector,
    XButton,
    Popup,
    Confirm
  },
  data() {
    return {
      show: false, // 是否显示提示弹窗
      maxperiodDays: null, // 保养周期最大值
      plate_number: '',
      is_disabled: false,
      fixed_maintain_date: '',
      maintenace: {
        ins_type: 1,
        last_maintain_date: util.formatTime(new Date(), 'yyyy-MM-dd'), // 保养日期
        free_ins_left_count: null, // 免保剩余
        last_maintain_mileage: null, // 最后保养里程
        repair_category_id: '', // 动力类型
        purchase_date: '', // 购车日期
        solicit_car_id: ''
      },
      maintenanceTrialConfirm: false,
      powerTypeList: [
        {
          key: '',
          value: '请选择'
        }
      ],
      showRelatedPlateNumberPopup: false, // 关联车牌号
      plateNumberList: [],
      startDate: '1990-01-01', // 日期选择器的结束时间
      endDate: util.formatTime((Date.now()), 'yyyy-MM-dd'), // 日期选择器的结束时间
      insOptions: [{
        key: 1,
        value: '保内'
      }, {
        key: 2,
        value: '保外'
      }],
      registerOptions: [{
        key: '1',
        value: '进店'
      }, {
        key: '2',
        value: '进车间'
      }],
      timer: null
    }
  },
  filters: {
  },
  created() {
    this.getSolocitCarPowerType()
  },
  onUnload() {
    clearTimeout(this.timer)
  },
  methods: {
    handleClearRelatedPlateNumber () {
      this.plate_number = ''
      this.maintenace.solicit_car_id = ''
      this.is_disabled = false
    },
    async getSolocitCarPowerType() {
      const { code, data, message } = await this.$rest.appointment.getSolocitCarPowerType()
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.powerTypeList = data.map(({ id, title }) => ({
        key: id,
        value: title
      }))
    },
    async handleSelectRelatedPlateNumber(item) {
      this.switchLoading({ status: true, text: '加载中...' })
      this.plate_number = item.plate_number
      const { code, data, message } = await this.$rest.appointment.getsolicitCarDetails(item.solicit_car_id)()
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.switchLoading({ status: false })
      this.is_disabled = true
      this.maintenace.free_ins_left_count = data.free_ins_left_count
      this.maintenace.ins_type = data.ins_type
      // 关联车辆后对于保养日期、保养里程非读取车辆的信息，不会被清空
      this.maintenace.last_maintain_date = data.last_maintain_date || this.maintenace.last_maintain_date || ''
      this.maintenace.last_maintain_mileage = data.last_maintain_mileage || this.maintenace.last_maintain_mileage || ''
      this.maintenace.repair_category_id = data.repair_category_id
      this.maintenace.purchase_date = data.purchase_date || ''
      this.maintenace.solicit_car_id = data.solicit_car_id
      this.showRelatedPlateNumberPopup = false
    },
    insTypeChange(type) {
      this.maintenace.ins_type = type
    },
    async handleSubmit() { // 试算
      const {
        solicit_car_id: solicitCarId,
        last_maintain_mileage: mileage,
        ins_type: insType,
        free_ins_left_count: count
      } = this.maintenace
      if (!solicitCarId) delete this.maintenace.solicit_car_id
      if (insType === 1 && !(this.checkSecurity(count))) {
        this.showToast('免保剩余只能为1-20之间整数')
        return
      }
      // 保内-里程非必填；保外：里程必填
      if ((insType !== 1 && !(this.checkSecurity(mileage))) || (mileage && !(this.checkSecurity(mileage)))) {
        this.showToast('请输入正确的保养里程')
        return
      }
      this.maintenace = util.clearNullProp({
        ...this.maintenace,
        free_ins_left_count: +count,
        last_maintain_mileage: +mileage === 0 ? null : +mileage
      })
      this.switchLoading({ status: true, text: '加载中...' })
      const { code, data, message } = await this.$rest.appointment.creatSolocitCarFixedMaintainDateClac(this.maintenace)
      this.switchLoading({ status: false })
      if (code === 1201) {
        this.maxperiodDays = data.max_period_days
        this.maintenanceTrialConfirm = true
        return
      }
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.fixed_maintain_date = data.fixed_maintain_date || '--'
      this.maxperiodDays = null
      this.maintenanceTrialConfirm = true
    },
    checkSecurity (num) {
      return (/^[1-9]+[0-9]*]*$/.test(num))
    },
    handleFixedMaintainDateSync() {
      this.maintenanceTrialConfirm = false
      this.show = true
    },
    handleOnCancel () {
      this.maintenanceTrialConfirm = true
      this.show = false
    },
    async handleOnConfirm() {
      const { code, message } = await this.$rest.appointment.creatSolocitCarFixedMaintainDateSync(this.maintenace)
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.show = false
      this.showToast('同步成功！')
    },
    async handlePlateNumberInput() {
      this.switchLoading({ status: true, text: '加载中...' })
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const { code, data, message } = await this.$rest.appointment.getSolicitCarCarInfo({ plate_number: this.plate_number })
        this.switchLoading({ status: false })
        if (code !== 0) {
          this.showToast(message)
          return
        }
        this.plateNumberList = data
      }, 1000)
    }
  }
}
</script>

<style lang="less">
@import "../../stylesheets/base/fn";
.maintenace{
  .weui_label{
    padding-right: 0;
  }
  .type-disabled{
    .weui_cell_primary{
      flex: 0;
    }
  }
  &-trial__result{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 11111;
    background: #fff;
    transform: translate(-50%,-50%);
    width: 88%;
    text-align: center;
    .radius(5/@w2);
    &-title{
      font-weight: bold;
      font-size: 34/@w2;
    }
    &-date{
      font-size: 30/@w2;
      color: #999;
      padding: 40/@w2 0 36/@w2;
      p{
        padding: 30/@w2;
        color: #409eff;
        font-size: 40/@w2;
      }
    }
    &-txt{
      margin: 40/@w2 20/@w2;
      height: 110/@w2;
      font-size: 30/@w2;
      color: #999;
    }
    &-btn{
      margin: 40/@w2 0;
      height: 110/@w2;
      line-height: 110/@w2;
      display: inline-block;
      width: 306/@w2 !important;
      font-size: 28/@w2;
      box-sizing: border-box;
      background-color: #3a5999;
      color: #fff;
      box-shadow: 0px 0.5px 0px 0px #d9d9d9;
    }
  }
  &__plate{
    .weui_cell{
      padding: 0;
    }
  }
  &__popup-plate {
    height: 100%;
    overflow: auto;
    background: #fff;
  }
  &__popup-default{
    .maintenace__popup-plate{
      background: #eee !important;
    }
  }
  .search-popupp{
    margin: 0 30/@w2;
    padding: 30/@w2 0;
    box-shadow: 0px 1px 0px 0px #ededed;
    &__items{
      &-number{
        font-size: 30/@w2;
        line-height: 42/@w2;
        color: #000;
      }
      &-name{
        line-height: 38/@w2;
        color: #999;
      }
    }
  }
  .btn-radius {
    min-width: 150/@w2;
    height: 60/@w2;
    line-height: 60/@w2;
    background-color: #fff;
    font-size: 28/@w2;
    z-index: 2;
    .radius(5/@w2);
    color: #409eff;
    border: solid 1/@w2;
    &::after{
      border: 0;
    }
    &.weui_btn_default:not(.weui_btn_disabled):active {
      color: #409eff;
      background-color: #fff;
    }
  }
  .time-picker{
    p{
      width: 180/@w2;
    }
  }
  .ins-radio {
    display: flex;
    .weui_cell_radio {
      padding: 0;
      margin-right: 80/@w2;
      flex-direction: row-reverse;
      &::before {
        height: 0;
        border-top: 0;
      }
      .weui_icon_checked {
        display: block;
        width: 32/@w2;
        height: 32/@w2;
        border: 2/@w2 solid #e7e7e9;
        border-radius: 50%;
        box-sizing: border-box;
      }
    }
    .weui_cell_ft {
      padding-left: 0;
      margin-right: 20/@w2;
      align-self: center;
    }
    .weui_check:checked + .weui_icon_checked {
      position: relative;
      border: 2/@w2 solid #509eff;
    }
    .weui_check:checked + .weui_icon_checked:before {
      display: block;
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 20/@w2;
      height: 20/@w2;
      margin: auto;
      border-radius: 50%;
      background-color: #509eff;
    }
  }
  .search-header{
    background-color: #eee;
    display: flex;
    justify-content: space-around;
    padding: 30/@w2;

    &__input{
      width: 100%;
      height: 80/@w2;
      line-height: 80/@w2;
      border: none;
      color: #948d8d;
      padding-left: 20/@w2;
      box-sizing: border-box;
      font-size: 24/@w2;
    }

    &__button{
      width: 20%;
      height: 80/@w2;
      line-height: 80/@w2;
      background: #3b5999;
      color: #fff;
    }
  }
  .appointment-btn-bottom {
    position: relative;
    z-index: 10;
    padding-top: 58/@w;
    .appointment-btn-fix {
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
      font-size: 30/@w2;
      height: 96/@w2;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      display: -webkit-box;
      display: box;
      border-radius: 0px;
      color: #948d8d;
      background-color: #ccc;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      box-align: center;
      justify-content: center;
      align-items: center;
      &.active {
        background: #3b5999;
        color: #fff;
      }
    }
    .appointment-btn-fix:after{
      border-radius: 0px;
      border: none;
    }
  }
}
</style>
